<template>
    <div class="alert-black-bg2" v-if="isNoticeOpen && isNoticeOpen2 && noticeInfo.length > 0">
        <div class="card alert-white-bg2">
            <!-- <div class="card-body">
                <h5 class="card-title"><i class="fas fa-exclamation-circle text-onmaum"></i> 최근 변경 사항 안내(2023.05.01.)</h5>
                <p class="card-text" style="overflow-y: auto; min-height:40vh; max-height: 50vh; padding: 1rem;">
                    <ul style="list-style: none;">
                        <li class="mb-3">
                            <span style="font-weight: 600; font-size: 1.2rem; color: #FF931E">1. '고객 관리' 메뉴 삭제 및 '고객 정보' 메뉴에 기능 통합</span><br/>
                            <span style="font-weight: 550;"> - '고객 관리'의 고객 추가/수정/삭제 기능을 '고객 정보'로 통합</span><br/>
                            <span style="font-weight: 550;"> - '고객 정보' 메뉴에서 고객 이름 클릭 시 고객을 관리할 수 있도록 변경</span>
                        </li>
                        <li class="mb-3">
                            <span style="font-weight: 600; font-size: 1.2rem; color: #FF931E">2. 고객 정보에 '체결 정보' 추가</span><br/>
                            <span style="font-weight: 550;"> - 체결여부, 체결일, 보험료 정보 추가</span><br/>
                            <span style="font-weight: 550;"> - '고객 정보' 번호에 체결여부 색깔로 구분(붉은색: 미체결 / 푸른색: 체결)</span><br/>
                            <span style="font-weight: 550;"> - '고객 정보'에서 체결 정보가 보이지는 않지만, 엑셀 출력 시에는 체결여부 정보 포함돼서 다운로드 됨</span>
                        </li>
                        <li class="mb-3">
                            <span style="font-weight: 600; font-size: 1.2rem; color: #FF931E">3. 각 플래너별 담당 고객만 조회</span><br/>
                            <span style="font-weight: 550;"> - 플래너 본인의 고객만 조회되도록 수정</span><br/>
                            <span style="font-weight: 550; color: red;"> - (주의!)고객을 추가할 때 플래너 정보를 넣지 않고 저장하면 조회되지 않아 바로 수정이 불가함</span><br/>
                            <span style="font-weight: 550;"> - 플래너 정보 미입력으로 저장 시 관리자(팀장)에게 플래너 정보 입력해달라 요청하기</span>
                        </li>
                        <li class="mb-3">
                            <span style="font-weight: 600; font-size: 1.2rem; color: #FF931E">4. 메모별 날짜 항목 추가</span><br/>
                            <span style="font-weight: 550;"> - 각 메모별로 날짜를 입력할 수 있습니다.</span><br/>
                            <span style="font-weight: 550;"> - 고객 정보 '메모' 영역에 날짜도 같이 출력 됩니다.</span><br/>
                            <span style="font-weight: 550;"> - 메모 내용 없이 날짜만 입력은 안 됩니다.</span><br/>
                            <span style="font-weight: 550;"> - 날짜 없이 메모만 입력은 가능합니다.</span>
                        </li>
                        <li class="mb-3">
                            <span style="font-weight: 600; font-size: 1.2rem;">※ 이 외의 요청사항은 개발 완료되면 반영하겠습니다.(캘린더, 통계)</span><br/>
                            <span style="font-weight: 600; font-size: 1.2rem; color: red;">※ 오류/불편/개선 사항 등이 있으시면 '개선 요청'에 올려주세요!</span>
                        </li>
                    </ul>
                    
                </p>
                <div class="row">
                    <div class="col-md-12">
                        <button class="btn btn-onmaum w-100" @click="setNoticeNone(0)">닫기</button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-secondary w-100" @click="setNoticeNone(1)">오늘 그만 보기</button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-danger w-100" @click="setNoticeNone(7);">일주인간 보지 않기</button>
                    </div>
                </div>
            </div> -->
            <!-- <div class="card-body">
                <h5 class="card-title"><i class="fas fa-exclamation-circle text-onmaum"></i> 최근 변경 사항 안내(2023.05.09.)</h5>
                <p class="card-text" style="overflow-y: auto; min-height:40vh; max-height: 50vh; padding: 1rem;">
                    <ul style="list-style: none;">
                        <li class="mb-3">
                            <span style="font-weight: 600; font-size: 1.2rem; color: #FF931E">* 메인페이지에 '등록/체결 현황' 정보란 추가!</span><br/>
                            <span style="font-weight: 550;"> - 원하는 기간(전체,한 달,한 주,오늘)에 등록/체결한 정보 조회 기능</span><br/>
                            <span style="font-weight: 550;"> - (각 플래너) 본인 고객의 등록/체결 정보 요약</span><br/>
                            <span style="font-weight: 550;"> - (관리자) 전체 플래너 현황 보임</span><br/>
                            <span style="font-weight: 550;"> - (관리자) 보험료계 > 체결건수 > 체결률 > 평균보험료 > 등록고객수 순으로 정렬됨</span><br/>
                            <span style="font-weight: 550; color: red;"> - (관리자) 플래너명이 '미상'인 것은 플래너가 할당되지 않은 고객이므로 확인 요망</span>
                        </li>
                        <li class="mb-3">
                            <span style="font-weight: 600; font-size: 1.2rem;">※ 이 외의 요청사항은 개발 완료되면 반영하겠습니다.(캘린더)</span><br/>
                            <span style="font-weight: 600; font-size: 1.2rem; color: red;">※ 오류/불편/개선 사항 등이 있으시면 '개선 요청'에 올려주세요!</span>
                        </li>
                    </ul>
                    
                </p>
                <div class="row">
                    <div class="col-md-12">
                        <button class="btn btn-onmaum w-100" @click="setNoticeNone(0)">닫기</button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-secondary w-100" @click="setNoticeNone(1)">오늘 그만 보기</button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-danger w-100" @click="setNoticeNone(7);">일주일간 보지 않기</button>
                    </div>
                </div>
            </div> -->
            <!-- <div class="card-body">
                <h5 class="card-title"><i class="fas fa-exclamation-circle text-onmaum"></i> 최근 변경 사항 안내(2023.05.15.)</h5>
                <p class="card-text" style="overflow-y: auto; min-height:40vh; max-height: 50vh; padding: 1rem;">
                    <ul style="list-style: none;">
                        <li class="mb-3">
                            <span style="font-weight: 600; font-size: 1.2rem; color: #FF931E">* 메인페이지에 '일자별 고객 등록/체결 현황' 추가!</span><br/>
                            <span style="font-weight: 550;"> - 주 단위로 등록/체결한 고객 및 플래너 목록 조회</span><br/>
                            <span style="font-weight: 550;"> - 등록: 회색 / <span style="color: #5e72e4;">체결: 푸른색</span></span><br/>
                            <span style="font-weight: 550;"> - 플래너명이 위, 고객명이 아래 괄호 안</span><br/>
                            <span style="font-weight: 550;"> - <span style="color: black;">같은 날 등록 및 체결</span>한 경우 <span style="color: black;">두 개 조회</span></span><br/>
                            <span style="font-weight: 550;"> - 우측 화살표로 주단위 변경</span><br/>
                            <span style="font-weight: 550;"> - 등록/체결 <span style="color: black;">건수가 많아</span>서 다 <span style="color: black;">보이지 않는 경우 스크롤</span>하여 보면 됩니다</span><br/>
                        </li>
                        <li class="mb-3">
                            <span style="font-weight: 600; font-size: 1.2rem; color: red;">※ 오류/불편/개선 사항 등이 있으시면 '개선 요청'에 올려주세요!</span>
                        </li>
                    </ul>
                    
                </p>
                <div class="row">
                    <div class="col-md-12">
                        <button class="btn btn-onmaum w-100" @click="setNoticeNone(0)">닫기</button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-secondary w-100" @click="setNoticeNone(1)">오늘 그만 보기</button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-danger w-100" @click="setNoticeNone(7);">일주일간 보지 않기</button>
                    </div>
                </div>
            </div> -->
            <div class="card-body">
                <h5 class="card-title"><i class="fas fa-exclamation-circle text-onmaum"></i> {{ noticeInfo[0].title }} </h5>
                <!-- <p id="contentArea" class="card-text" style="overflow-y: auto; min-height:40vh; max-height: 50vh; min-width: 40vw; padding: 1rem;">
                    {{ noticeInfo[0].content }}
                </p> -->
                <div id="viewer" class="onmaum-overflow-y onmaum-overflow-type02 onmaum-minh-40-v onmaum-minw-50-v onmaum-maxh-70-v"></div>
                <div class="row mt-2">
                    <div class="col-md-6">
                        <button class="btn btn-onmaum w-100" @click="setNoticeNone(0)">닫기</button>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-secondary w-100" @click="setNoticeNone(1)">오늘 그만 보기</button>
                    </div>
                    <!-- <div class="col-md-6">
                        <button class="btn btn-danger w-100" @click="setNoticeNone(7);">일주일간 보지 않기</button>
                    </div> -->
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import '@toast-ui/editor/dist/i18n/ko-kr';

let viewer = null;

export default {
    name: 'noticeModal',
    data(){
        return {
            isNoticeOpen2: true,
        }
    },
    props:{
        isNoticeOpen: Boolean,
        noticeInfo: Array,
    },
    methods:{
        setNoticeNone(day) {
            if(day != 0){
                let dt = new Date();
                dt.setDate(dt.getDate() + 1);
                let expTime = new Date(dt.toLocaleDateString());

                // this.$cookies.set('isNoticeOpen', false, `${day}d`); //입력받은 일수만큼
                this.$cookies.set('isNoticeOpen', false, expTime); //오늘 하루(자정) 까지
                
            }
            this.isNoticeOpen2 = false;
        }
    },

     mounted(){
        viewer = new Viewer({
            el: document.getElementById('viewer'),
            viewer: true,
            height: '50vh',
            initialValue: '',
            language: 'ko'
        });

        viewer.setMarkdown(`${this.noticeInfo[0].content}`);
    },
}
</script>

<style>
.alert-black-bg2 {
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  padding: 20px;
  z-index: 9999;

  justify-content: center;
  align-items: center;
  display: flex;
}

.alert-white-bg2 {
  background: white;
  width: auto;
  max-width: 75%;
  height: auto;
  position: relative;
  margin: auto;
  padding: 10px;
  border-radius: 8px;
}

.v-enter,
.v-leave-to {
    opacity: 0;
}

.v-enter-active,
.v-leave-active {
    transition: all 0.2s ease;
}
</style>